/* global fetch */

import { config } from '../config';
import { APIResponse, fetchAPI, headers, SpanTag, stleaf } from '../helpers';


export const getById = (
  st: SpanTag,
  planId: string,
) => {
  const url = new URL(`${config.API_URL}/v2/plans/${planId}`);
  return fetchAPI(stleaf(st, '29fktu'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

